import {
  createCharge as createChargeApi,
  getBilling as getBillingApi,
  showCharge as showChargeApi
} from './api'

let getBilling = (params) => dispatch => {
  return getBillingApi(params)
}

let createCharge = (params, data) => dispatch => {
  return createChargeApi(params, data)
}

let showCharge = (chargeId) => dispatch => {
  return showChargeApi(chargeId)
}

export {
  createCharge,
  getBilling,
  showCharge
}
